// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__ujKWY","paramInput":"JobSimulator_paramInput__tbJOz","input":"JobSimulator_input__1wwas"};